import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Briefing from "@/pages/Briefing";
import Station from "@/pages/Station";
import Accusation from "@/pages/Accusation";
import Production from "@/pages/Production";
import { Layout } from "@/components/Layout";

function App() {
  return (
    <div className="App relative min-h-screen">
      <div className="chrome-bg" aria-hidden />
      <BrowserRouter>
        <Routes>
          <Route path="/production" element={<Production />} />
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="briefing" element={<Briefing />} />
            <Route path="suspects/:sid" element={<Station />} />
            <Route path="charge" element={<Accusation />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="bottom-right" />
    </div>
  );
}

export default App;
